import React, { useState } from "react";
import Logo from "../../components/Logo";
import SociaIcons from "../../components/SocialIcons";
import useWindowDimensions from "../../Utilities/useWindowDimensions";
import "./comingsoon.scss";
import IntroText from "./IntroText";
import BottomLogo from "../../components/BottomLogo";
import RegisterSuccess from "./RegisterSuccess";
import RegisterForm from "../RegisterForm";

const ComingSoon = () => {
  const { width } = useWindowDimensions();  
  const [registerSuccess, setRegisterSuccess] = useState(false);

  return (
    <section id="coming-soon-page">
      <div className="container">
        <div className="page-content">
            <IntroText success={registerSuccess}/>
          {!registerSuccess ? (<>
            <RegisterForm onSuccess={() => setRegisterSuccess(true)} />
            </>
          ) : (
            <RegisterSuccess />
          )}
        </div>
        <br />
        <div>
        {width < 1000 && (
          <>
          <div className="cabiLogoContainer">
            <Logo variant={"alt"} />
          </div>
            <br />
            <br />
          </>
        )}
        <SociaIcons variant={"alt"}/>
        {width>=1000 && <BottomLogo variant="alt"/>}
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
